import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Mail_Lottie from "../../../animation/mail_lottie/Mail_Lottie";
import Orange_White_Border_Btn from "../../common_btn/orange_white_border_btn/Orange_White_Border_Btn";
import "./Verification_Steps_Modal.css";
import Phone_Lottie from "../../../animation/phone_lottie/Phone_Lottie";
import Profile_Info_Lottie from "../../../animation/profile_info_lottie/Profile_Info_Lottie";
import Id_Proof_Lottie from "../../../animation/id_proof_lottie/Id_Proof_Lottie";
import Verify_Profile_Modal from "../verify_profile_modal/Verify_Profile_Modal";

const Verification_Steps_Modal = (props) => {
  const [showModal, setShowModal] = useState(false);

  const steps = [
    {
      step: 1,
      title: "01. Confirm Email Address",
      subtitle: "xyz@gmail.com",
      status: "completed",
    },
    {
      step: 2,
      title: "02. Confirm Phone Number",
      subtitle: "Make Your Account More Secure",
      status: "completed",
    },
    {
      step: 3,
      title: "03. Add Profile Information",
      subtitle: "Get A More Tailored Experience",
      status: "completed",
    },
    {
      step: 4,
      title: "04. Add ID Proof",
      subtitle: "Verify Your Profile With Identification",
      status: "",
    },
  ];

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="premium-verification-modal py-12 "
      >
        <Modal.Header closeButton className="modal-header-custom ">
          <Modal.Title className="modal-title">Complete Your Verification</Modal.Title>
        </Modal.Header>

        <Modal.Body className="modal-body-custom">
          <div className="intro-note">
            <p>This process takes less than 5 minutes</p>
          </div>

          <div className="steps-grid">
            {steps.map((step, index) => (
              <div
                key={index}
                className={`step-card ${step.status === "completed" ? "completed" : ""} ${
                  step.step === 4 ? "active-step" : ""
                }`}
              >
                <div className="step-number">
                  {step.status === "completed" ? (
                    <span className="checkmark">✓</span>
                  ) : (
                    step.step
                  )}
                </div>

                <div className="step-animation">
                  {step.step === 1 && <Mail_Lottie />}
                  {step.step === 2 && <Phone_Lottie />}
                  {step.step === 3 && <Profile_Info_Lottie />}
                  {step.step === 4 && <Id_Proof_Lottie />}
                </div>

                <h5 className="step-title">{step.title}</h5>
                <p className="step-subtitle">{step.subtitle}</p>
              </div>
            ))}
          </div>

          <div className="action-footer">
            <Orange_White_Border_Btn
              btn_name="Add ID Proof"
              onClick={() => {
                setShowModal(true);
                props?.onHide();
              }}
              className="primary-action-btn"
            />

            <button
              className="later-link"
              onClick={() => props?.onHide()}
            >
              Do It Later
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Verify_Profile_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
      />
    </>
  );
};

export default Verification_Steps_Modal;